import React from "react";
import Badge from "@/components/ui/badge";
import IconContainer from "@/components/ui/icon-container";
import { useTranslation } from "react-i18next";

interface CountBadgeProps {
  count: number;
  icon: React.ReactNode;
  translationKey: string;
  tPrefix: string;
}

const CountBadge: React.FC<CountBadgeProps> = ({
  count,
  icon,
  translationKey,
  tPrefix
}) => {
  const { t } = useTranslation();

  if (count <= 0) return null;

  const translatedWord = t(`${tPrefix}.${translationKey}`, { count });
  const text = `${count} ${translatedWord}`;

  return (
    <Badge
      className="pl-[2px] gap-[6px] pr-2 py-[6px] border-none bg-transparent"
      icon={
        <IconContainer className="size-[18px]" color="secondary">
          {icon}
        </IconContainer>
      }
      textVariant="bodySecondary"
      text={text}
    />
  );
};

export default CountBadge;
